"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _taggedTemplateLiteralLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteralLoose"));

var _I18n = _interopRequireDefault(require("I18n"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _classnames = _interopRequireDefault(require("classnames"));

var _emptyFunction = _interopRequireDefault(require("react-utils/emptyFunction"));

var _colors = require("HubStyleTokens/colors");

var _sizes = require("HubStyleTokens/sizes");

var _UIIconHolder = _interopRequireDefault(require("../icon/UIIconHolder"));

var _BrowserTest = require("../utils/BrowserTest");

var _createLazyPropType = _interopRequireDefault(require("../utils/propTypes/createLazyPropType"));

var _lazyEval = _interopRequireDefault(require("../utils/lazyEval"));

var _tshirtSize = require("../utils/propTypes/tshirtSize");

var _LoadingConstants = require("./LoadingConstants");

function _templateObject10() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  animation: ", " 2s cubic-bezier(0.42, 0, 0.58, 1) infinite,\n    ", " 2s linear infinite;\n  stroke-dasharray: none;\n  stroke-dashoffset: 0;\n  stroke-linecap: round;\n  transform-origin: center;\n  ", "\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  display: block;\n  max-width: 100%;\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n      animation: ", " 2s linear infinite;\n    "]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  opacity: 1;\n  transition: opacity 0.2s cubic-bezier(0.42, 0, 0.58, 1),\n    transform 0.2s cubic-bezier(0.89, 0.03, 0.68, 0.22);\n  ", "\n\n  ", "\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  justify-content: center;\n  opacity: 0;\n  position: absolute;\n  transform: scale(0.7);\n  transition: opacity 0.2s cubic-bezier(0.42, 0, 0.58, 1) 0.1s,\n    transform 0.3s cubic-bezier(0.2, 0.9, 0.3, 2) 0.1s;\n  ", "\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  margin-top: ", ";\n\n  &:not(:empty) {\n    margin-left: ", ";\n    margin-right: ", ";\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  align-items: center;\n  display: flex;\n  height: ", ";\n  justify-content: center;\n  width: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  position: relative;\n  align-items: center;\n  color: ", ";\n  display: flex;\n  flex-direction: ", ";\n  justify-content: ", ";\n  ", ";\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  0% {\n    stroke-dasharray: 1, 150;\n    stroke-dashoffset: 0;\n  }\n  50% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -50;\n  }\n  100% {\n    stroke-dasharray: 90, 150;\n    stroke-dashoffset: -140;\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = (0, _taggedTemplateLiteralLoose2.default)(["\n  100% {\n    transform: rotate(360deg)\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

var getSpinnerSize = function getSpinnerSize(sizeName) {
  return _LoadingConstants.SIZE_OPTIONS[sizeName] || _LoadingConstants.SIZE_OPTIONS['small'];
};

var privateSpin = (0, _styledComponents.keyframes)(_templateObject());
var privateDash = (0, _styledComponents.keyframes)(_templateObject2());

var SpinnerOuter = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__SpinnerOuter",
  componentId: "g6fohf-0"
})(_templateObject3(), function (props) {
  return props.use === 'on-dark' ? _colors.OLAF : 'currentColor';
}, function (props) {
  return props.layout === 'centered' && 'column';
}, function (props) {
  return props.layout === 'centered' && 'center';
}, function (props) {
  return props.grow ? "width: 100%; height: 100%;" : 'margin: 8px';
});

var SpinnerInner = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__SpinnerInner",
  componentId: "g6fohf-1"
})(_templateObject4(), function (props) {
  return getSpinnerSize(props.size);
}, function (props) {
  return getSpinnerSize(props.size);
});

var SpinnerLabel = _styledComponents.default.span.withConfig({
  displayName: "UILoadingSpinner__SpinnerLabel",
  componentId: "g6fohf-2"
})(_templateObject5(), function (props) {
  return props.layout === 'centered' && _sizes.BASE_ICON_SPACING_X;
}, _sizes.BASE_ICON_SPACING_X, _sizes.BASE_ICON_SPACING_X);

var ResultSpinner = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__ResultSpinner",
  componentId: "g6fohf-3"
})(_templateObject6(), function (_ref) {
  var displayResult = _ref.displayResult;
  return displayResult && "opacity: 1;\n    position: relative;\n    transform: scale(1);\n  ";
});

var SpinnerWrapper = _styledComponents.default.div.withConfig({
  displayName: "UILoadingSpinner__SpinnerWrapper",
  componentId: "g6fohf-4"
})(_templateObject7(), (0, _BrowserTest.isIE11)() && (0, _styledComponents.css)(_templateObject8(), privateSpin), function (_ref2) {
  var displayResult = _ref2.displayResult;
  return displayResult && "margin-left: -1px;\n    opacity: 0;\n    transform: scale(.7);\n    width: 1px;\n  ";
});

var Ring = _styledComponents.default.svg.withConfig({
  displayName: "UILoadingSpinner__Ring",
  componentId: "g6fohf-5"
})(_templateObject9());

var RingPath = _styledComponents.default.circle.withConfig({
  displayName: "UILoadingSpinner__RingPath",
  componentId: "g6fohf-6"
})(_templateObject10(), privateDash, privateSpin, (0, _BrowserTest.isIE11)() && "stroke-dasharray: 50, 150;");

var getComputedStyle = function getComputedStyle(style, grow, minHeight) {
  if (minHeight) {
    var computedStyle = (0, _extends2.default)({}, style, {
      minHeight: minHeight
    });
    if (!grow) computedStyle.height = '1rem';
    return computedStyle;
  }

  return style;
};

var resultIconStyles = {
  lineHeight: 'inherit',
  verticalAlign: 'middle'
};

var UILoadingSpinner =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(UILoadingSpinner, _PureComponent);

  function UILoadingSpinner(props) {
    var _this;

    (0, _classCallCheck2.default)(this, UILoadingSpinner);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(UILoadingSpinner).call(this, props));
    _this.state = {
      displayResult: props.showResult
    };
    return _this;
  }

  (0, _createClass2.default)(UILoadingSpinner, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var showResult = this.props.showResult;

      if (showResult) {
        this.setResultDisplayTimeout();
      }
    }
  }, {
    key: "UNSAFE_componentWillReceiveProps",
    value: function UNSAFE_componentWillReceiveProps(nextProps) {
      var showResult = nextProps.showResult;

      if (this.state.displayResult !== showResult) {
        this.setState({
          displayResult: showResult
        });
      }
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      if (!prevState.displayResult && this.state.displayResult) {
        this.setResultDisplayTimeout();
      } else if (prevState.displayResult && !this.state.displayResult) {
        clearTimeout(this.resultDisplayTimeout);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.resultDisplayTimeout);
    }
  }, {
    key: "setResultDisplayTimeout",
    value: function setResultDisplayTimeout() {
      var _this$props = this.props,
          onResultDisplayFinish = _this$props.onResultDisplayFinish,
          resultAnimationDuration = _this$props.resultAnimationDuration;
      clearTimeout(this.resultDisplayTimeout);
      this.resultDisplayTimeout = setTimeout(onResultDisplayFinish, resultAnimationDuration);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          className = _this$props2.className,
          failed = _this$props2.failed,
          showResult = _this$props2.showResult,
          dataLoading = _this$props2['data-loading'],
          grow = _this$props2.grow,
          label = _this$props2.label,
          labelCompletedText = _this$props2.labelCompletedText,
          layout = _this$props2.layout,
          minHeight = _this$props2.minHeight,
          __resultAnimationDuration = _this$props2.resultAnimationDuration,
          resultIcon = _this$props2.resultIcon,
          use = _this$props2.use,
          showLabel = _this$props2.showLabel,
          size = _this$props2.size,
          style = _this$props2.style,
          __onResultDisplayFinish = _this$props2.onResultDisplayFinish,
          rest = (0, _objectWithoutProperties2.default)(_this$props2, ["className", "failed", "showResult", "data-loading", "grow", "label", "labelCompletedText", "layout", "minHeight", "resultAnimationDuration", "resultIcon", "use", "showLabel", "size", "style", "onResultDisplayFinish"]);
      var displayResult = this.state.displayResult;
      var computedLayout = layout || (grow ? 'centered' : 'inline');
      var computedLabelText = displayResult && !failed ? (0, _lazyEval.default)(labelCompletedText) : (0, _lazyEval.default)(label);
      var RenderedLabel = showLabel ? SpinnerLabel : 'span';
      var renderedLabelProps = {
        children: computedLabelText
      };

      if (showLabel) {
        renderedLabelProps.layout = computedLayout;
      } else {
        renderedLabelProps.className = 'sr-only';
      }

      var longhandSize = (0, _tshirtSize.toLonghandSize)(size);
      var spinnerSizePx = parseInt(getSpinnerSize(longhandSize), 10);
      return _react.default.createElement(SpinnerOuter, (0, _extends2.default)({}, rest, {
        className: (0, _classnames.default)('private-spinner', className),
        style: getComputedStyle(style, grow, minHeight),
        "data-loading": dataLoading !== undefined ? dataLoading : !showResult,
        layout: computedLayout,
        grow: grow,
        use: use
      }), _react.default.createElement(SpinnerInner, {
        size: longhandSize
      }, _react.default.createElement(SpinnerWrapper, {
        displayResult: displayResult
      }, _react.default.createElement(Ring, {
        height: spinnerSizePx,
        width: spinnerSizePx,
        viewBox: "0 0 50 50",
        stroke: _LoadingConstants.USE_COLORS[use]
      }, _react.default.createElement("circle", {
        cx: "25",
        cy: "25",
        r: "22.5",
        fill: "none",
        strokeWidth: "5"
      }), _react.default.createElement(RingPath, {
        cx: "25",
        cy: "25",
        r: "22.5",
        fill: "none",
        stroke: _LoadingConstants.USE_INDICATOR_COLORS[use],
        strokeWidth: "5"
      }))), resultIcon && !failed && _react.default.createElement(ResultSpinner, {
        displayResult: displayResult
      }, _react.default.createElement(_UIIconHolder.default, {
        innerStyles: resultIconStyles,
        name: resultIcon,
        color: _LoadingConstants.ICON_COLOR_MAP[use],
        size: _LoadingConstants.ICON_SIZE_MAP[longhandSize] || _LoadingConstants.ICON_SIZE_MAP['small']
      }))), _react.default.createElement(RenderedLabel, renderedLabelProps));
    }
  }]);
  return UILoadingSpinner;
}(_react.PureComponent);

UILoadingSpinner.displayName = 'UILoadingSpinner';
UILoadingSpinner.propTypes = {
  'data-loading': _propTypes.default.bool,
  failed: _propTypes.default.bool,
  showResult: _propTypes.default.bool,
  label: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  labelCompletedText: (0, _createLazyPropType.default)(_propTypes.default.node).isRequired,
  layout: _propTypes.default.oneOf(['inline', 'centered']),
  minHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
  grow: _propTypes.default.bool,
  resultAnimationDuration: _propTypes.default.number.isRequired,
  resultIcon: _propTypes.default.string,
  use: _propTypes.default.oneOf(_LoadingConstants.USES),
  showLabel: _propTypes.default.bool.isRequired,
  size: (0, _tshirtSize.propTypeForSizes)(['xs', 'sm', 'md']),
  onResultDisplayFinish: _propTypes.default.func
};
UILoadingSpinner.defaultProps = {
  failed: false,
  grow: false,
  label: function label() {
    return _I18n.default.text('ui.UILoadingSpinner.busyText');
  },
  labelCompletedText: function labelCompletedText() {
    return _I18n.default.text('ui.UILoadingSpinner.completedText');
  },
  showResult: false,
  resultAnimationDuration: 1500,
  resultIcon: 'success',
  role: 'status',
  onResultDisplayFinish: _emptyFunction.default,
  showLabel: false,
  size: 'small',
  use: 'link'
};
var _default = UILoadingSpinner;
exports.default = _default;
module.exports = exports.default;